import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CRM_SEARCH_ERROR_HANDLED } from './CrmSearchErrorNavMarker';
import { CrmSearchErrorNavMarker } from './CrmSearchErrorNavMarker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "CrmSearch403ErrorEmptyState__Container",
  componentId: "q1c725-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
export const CrmSearch403ErrorEmptyState = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    illustration: "keys",
    illustrationProps: {
      width: 200
    },
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectSearchQueryUtilities.errorStates.NoPermissionError.title"
      })
    }),
    children: [/*#__PURE__*/_jsx(CrmSearchErrorNavMarker, {
      name: CRM_SEARCH_ERROR_HANDLED
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectSearchQueryUtilities.errorStates.NoPermissionError.message"
        })
      })
    })]
  });
};